export default __webpack_public_path__ + "static/media/-_down.823eb40f.svg";